import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-custom-accordion',
    templateUrl: 'custom-accordion.component.html',
    styleUrls: ['custom-accordion.component.scss'],
})

export class CustomAccordionComponent implements OnInit {
    @Input() hidden = true;

    constructor() {
    }

    ngOnInit() {
    }

    toggle() {
        this.hidden = !this.hidden;
    }
}
